/**
 * Shared file-staging constants + validation for the maker logsheet flows.
 *
 * Used by:
 *  - DocumentUploadZone (legacy after-save uploader on the Edit page)
 *  - StagedFilesPicker  (new inline picker in the create + bulk wizards)
 *
 * Keeping a single source of truth here means a future change to the MIME
 * allowlist or size cap doesn't drift between the two pickers (and matches
 * the backend allowlist at LogsheetMakerService.UploadDocumentAsync).
 */

export const ALLOWED_MIMES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
] as const;

export const MAX_BYTES = 10 * 1024 * 1024;

/** Returns a user-facing error message, or null when the file is acceptable. */
export function validateStagedFile(file: File): string | null {
  if (!(ALLOWED_MIMES as readonly string[]).includes(file.type)) {
    return `Unsupported file type '${file.type}'. Allowed: PDF, JPEG, PNG.`;
  }
  if (file.size > MAX_BYTES) {
    return `File '${file.name}' exceeds the 10 MB limit.`;
  }
  return null;
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${String(n)} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(2)} MB`;
}
